export const RatingDisplay = ({
                                  value,
                                  size = 'sm',
                                  className = '',
                                  ariaLabel,
                              }) => {
    const displayValue = Math.round(value * 2) / 2;

    return (
        <div
            className={`rating rating-${size} rating-half pointer-events-none select-none ${className}`}
            role="img"
            aria-label={ariaLabel ?? `${displayValue} out of 5 stars`}
        >
            {[1, 2, 3, 4, 5].flatMap(star => ([
                <span
                    key={`${star}-half1`}
                    style={{opacity: 1}}
                    className={`mask mask-star-2 mask-half-1 ${
                        displayValue >= star - 0.5 ? 'bg-orange-400' : 'bg-gray-300'
                    }`}
                />,
                <span
                    key={`${star}-half2`}
                    style={{opacity: 1}}
                    className={`mask mask-star-2 mask-half-2 ${
                        displayValue >= star ? 'bg-orange-400' : 'bg-gray-300'
                    }`}
                />
            ]))}
        </div>
    );
};